import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  sidebarMenu: {
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    padding: theme.spacing(0, 0, 5, 0),
    position: 'relative',
    flex: 1,
    paddingBottom: theme.spacing(2)
  }
}));

export default useStyles;
